import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { XCircle, RefreshCw } from 'lucide-react';

const MobileCheckoutCancel = () => {
  const [searchParams] = useSearchParams();
  const checkoutId = searchParams.get('id');

  const handleRetry = () => {
    if (checkoutId) {
      window.location.href = `/mobile-checkout?id=${checkoutId}`;
    } else {
      window.history.back();
    }
  };

  return (
    <div className="min-vh-100 position-relative overflow-hidden" style={{ background: "#0a0a0f" }}>
      {/* Background */}
      <img 
        src="./images/giphy-new.gif" 
        alt="background" 
        className="position-absolute w-100 h-100 object-fit-cover" 
        style={{ opacity: 0.45 }} 
      />
      <div className="position-absolute w-100 h-100" style={{ background: "rgba(0,0,0,0.65)" }}></div>

      <div className="position-relative d-flex align-items-center justify-content-center min-vh-100 px-3">
        <div className="card shadow-lg border-0 text-center" style={{ maxWidth: "440px", borderRadius: "24px", overflow: "hidden" }}>
          
          {/* Accent Bar */}
          <div style={{ height: "6px", background: "linear-gradient(to right, #f97316, #fb923c)" }}></div>

          <div className="card-body p-5">
            <XCircle className="mx-auto text-warning mb-4" size={64} />

            <h2 className="fw-bold mb-3">Payment Cancelled</h2>
            <p className="text-muted mb-5 fs-5">No charges were made to your account.</p>

            <div className="d-grid gap-3">
              <button 
                onClick={handleRetry} 
                className="btn btn-lg d-flex align-items-center justify-content-center gap-2"
                style={{ backgroundColor: "#6366f1", color: "white", borderRadius: "14px", height: "56px" }}
              >
                <RefreshCw size={18} /> Try Again
              </button>

              <button 
                onClick={() => window.close()} 
                className="btn btn-outline-secondary btn-lg"
                style={{ borderRadius: "14px", height: "56px" }}
              >
                Return to App
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileCheckoutCancel;